import React, { Component } from 'react';
import { Image } from 'react-native';
import Box from '../Box';

// ///////////////////////////////////////////////////////////////////
// ///////////////////////////////////////////////////////////////////

const BaseImage = Box.withComponent(Image);

// eslint-disable-next-line react/prefer-stateless-function
export default class ImageComponent extends Component {
    render() {
        return <BaseImage {...this.props} />;
    }
}
